import React, { createContext, useContext, useEffect, useState } from 'react';

const TenantContext = createContext(null);
export const useTenant = () => useContext(TenantContext);

const PLATFORM_HOSTS = ['tapnvip.com', 'tapn.vip', 'localhost', '127.0.0.1'];

const isPlatformHost = (host) =>
  PLATFORM_HOSTS.some((h) => host === h || host.endsWith(`.${h}`)) ||
  host.includes('emergentagent.com') || host.includes('emergent.host');

export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    if (isPlatformHost(host)) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/b2b/whitelabel/resolve?host=${encodeURIComponent(host)}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.tenant) {
          setTenant(d.tenant);
          document.title = d.tenant.brand_name;
          if (d.tenant.primary_color) {
            document.documentElement.style.setProperty('--tenant-primary', d.tenant.primary_color);
          }
        }
      })
      .catch(() => {});
  }, []);

  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
}
